var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnotationHelper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 297,
    viewBox: "0 0 466 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_40)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 466,
    height: 297,
    fill: "black",
    fillOpacity: 0.83
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6_40)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 162,
    width: 466,
    height: 135,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.8 232.133C296.933 231.133 297 230.1 297 229C297 227.933 296.933 226.867 296.767 225.867L303.533 220.6C304.133 220.133 304.3 219.233 303.933 218.567L297.533 207.5C297.133 206.767 296.3 206.533 295.567 206.767L287.6 209.967C285.933 208.7 284.167 207.633 282.2 206.833L281 198.367C280.867 197.567 280.2 197 279.4 197H266.6C265.8 197 265.167 197.567 265.033 198.367L263.833 206.833C261.867 207.633 260.067 208.733 258.433 209.967L250.467 206.767C249.733 206.5 248.9 206.767 248.5 207.5L242.133 218.567C241.733 219.267 241.867 220.133 242.533 220.6L249.3 225.867C249.133 226.867 249 227.967 249 229C249 230.033 249.067 231.133 249.233 232.133L242.467 237.4C241.867 237.867 241.7 238.767 242.067 239.433L248.467 250.5C248.867 251.233 249.7 251.467 250.433 251.233L258.4 248.033C260.067 249.3 261.833 250.367 263.8 251.167L265 259.633C265.167 260.433 265.8 261 266.6 261H279.4C280.2 261 280.867 260.433 280.967 259.633L282.167 251.167C284.133 250.367 285.933 249.3 287.567 248.033L295.533 251.233C296.267 251.5 297.1 251.233 297.5 250.5L303.9 239.433C304.3 238.7 304.133 237.867 303.5 237.4L296.8 232.133ZM273 241C266.4 241 261 235.6 261 229C261 222.4 266.4 217 273 217C279.6 217 285 222.4 285 229C285 235.6 279.6 241 273 241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.333 235.667H357.667V252.333H374.333V245.667H364.333V235.667ZM357.667 222.333H364.333V212.333H374.333V205.667H357.667V222.333ZM397.667 245.667H387.667V252.333H404.333V235.667H397.667V245.667ZM387.667 205.667V212.333H397.667V222.333H404.333V205.667H387.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -17,
    y: 123,
    width: 468,
    height: 8,
    rx: 4,
    fill: "#D32F2F",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -228,
    y: 121,
    width: 468,
    height: 12,
    rx: 5,
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 127,
    r: 20,
    fill: "#D32F2F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180 252.233H140V211.5H163.333V204.833H140C136.333 204.833 133.333 207.833 133.333 211.5V251.5C133.333 255.167 136.333 258.167 140 258.167H180C183.667 258.167 186.667 255.167 186.667 251.5V228.167H180V252.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.667 194.833H180V204.833H170C170.033 204.867 170 211.5 170 211.5H180V221.467C180.033 221.5 186.667 221.467 186.667 221.467V211.5H196.667V204.833H186.667V194.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.333 218.167H146.667V224.833H173.333V218.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.667 228.167V234.833H173.333V228.167H163.333H146.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.333 238.167H146.667V244.833H173.333V238.167Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6_40",
    x: -233,
    y: 102,
    width: 704,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_6_40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 466,
    height: 297,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationHelper);
export default __webpack_public_path__ + "static/media/AnnotationHelper.26aacf0fd80131f1fb204614a8e97d56.svg";
export { ForwardRef as ReactComponent };